/*=========================================================================================
  File Name: store.js
  Description: Vuex store
 ==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

//import moduleCalendar from './calendar/moduleCalendar.js'

export default new Vuex.Store({
	getters,
	mutations,
	state,
  actions,
  modules: {
		//calendar: moduleCalendar,
	},
	strict: process.env.NODE_ENV !== 'production'
})
